module.exports = __webpack_public_path__ + "media/service-concept.e2c5be26.mp4";